import { render, staticRenderFns } from "./NavegacaoItens.vue?vue&type=template&id=5b72739c&scoped=true&lang=pug"
import script from "./NavegacaoItens.vue?vue&type=script&lang=js"
export * from "./NavegacaoItens.vue?vue&type=script&lang=js"
import style0 from "./NavegacaoItens.styl?vue&type=style&index=0&id=5b72739c&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b72739c",
  null
  
)

export default component.exports